import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { UserModuleOutput } from '../model/user-module.output';

export interface UpdateUserModuleCoachCommentInput {
	readonly coachComment: string;
	readonly moduleId: string;
	readonly userId: string;
}

export interface UpdateUserModuleCoachCommentParams {
	input: UpdateUserModuleCoachCommentInput;
}

@Injectable({ providedIn: 'root' })
export class UpdateUserModuleCoachCommentApiMutation extends ApiMutation<
	UserModuleOutput,
	UpdateUserModuleCoachCommentParams
> {
	client = 'content';
	document = gql`
		mutation UpdateUserModuleCoachComment(
			$input: UpdateUserModuleCoachCommentInput!
		) {
			updateUserModuleCoachComment(input: $input) {
				id
				isDone
				userId
				moduleId
				isStarted
				coachComment
				updateTimestamp
				moduleRatingValue
				moduleRatingComment
				module {
					id
				}
				pages {
					pageId
					activityUrl
					id
				}
			}
		}
	`;
	method = 'updateUserModuleCoachComment';
}
